import React from 'react'
import classes from './Footer.module.scss'
import call from './images/c-f.svg'
import mail from './images/mail.svg'
import fb from './images/fb.svg'
import tw from './images/tw.svg'
import ln from './images/ln.svg'
import { ContactInfo } from './ContactInfo/ContactInfo'
import Subscribe from './Subscribe/Subscribe'
import logo from './images/footerLogo.png'

const Footer = () => {

    const year = new Date().getFullYear();

    return (
        <div className={classes.footer}>
            <div className={classes.top}>
                <div className='container'>
                    <div className={classes.innerTop}>

                        <div className={classes.left}>
                            <div className={classes.topItem}>
                                <div className={`fb-page ${classes.plugin}`}
                                    data-href="https://www.facebook.com/pashalifeinsurance" 
                                    data-height="230"
                                    data-width="300"
                                    data-adapt-container-width="true"
                                    data-lazy='true'
                                    data-hide-cover="false"
                                    data-show-facepile="true">
                                </div>
                                </div>
                            <div className={classes.topItem}>
                                <Subscribe />
                            </div>
                        </div>

                        <div className={classes.topItem}>
                            <ContactInfo url='tel:012942' image={call}>012 942</ContactInfo>
                            <ContactInfo url='mailto:hys@pasha-life.az' image={mail}>hys@pasha-life.az</ContactInfo>
                            <ContactInfo url='https://facebook.com/pashalifeinsurance' image={fb}>facebook.com/pashalifeinsurance</ContactInfo>
                            <ContactInfo url='https://linkedin.com/company/pashalifeinsurance' image={ln}>LinkedIn</ContactInfo>
                        </div>
                    </div>
                </div>
            </div>

            <div className={classes.bottom}>
                <div className='container'>
                    <div className={classes.innerBottom}>
                        <div className={classes.left}>
                            <img src={logo} alt='Logo' />
                            {/* <p className='mb-0'><span>© 2011 - {year} </span>   " PAŞA Həyat Sığorta " ASC</p> */}
                        </div>

                        <div className={classes.right}>
                            {/* <a href='#'>Terms of Service</a>
                            <a href='#'>Privacy Policy</a> */}
                            <p className='mb-0'><span>© 2011 - {year} </span>   " PAŞA Həyat Sığorta " ASC</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer
